export default __webpack_public_path__ + "static/media/counterstike2.8b93b402.png";